import { useMemo, useState } from 'react';

import { Endpoints } from '@/api';
import { useBrands } from '@/models/brand';

const MINIMUM_ENTRIES_FOR_SEARCH = 5;

export const useBrandFilterState = (params: Endpoints['GET /brands']['query']) => {
  const [search, setSearch] = useState('');

  const { data } = useBrands(params);
  const allBrands = data?.brands ?? [];
  const hasBrands = !!data?.brands.length;

  const filteredBrands = useMemo(() => {
    const q = search.trim().toLowerCase();

    return (q ? allBrands.filter((brand) => brand.name.toLowerCase().includes(q)) : [...allBrands])
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [allBrands, search]);

  const showSearch = allBrands.length >= MINIMUM_ENTRIES_FOR_SEARCH;

  return {
    search,
    setSearch,
    allBrands,
    filteredBrands,
    showSearch,
    hasBrands,
  };
};
